<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstGuardian"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th>Name</th>
				<th>Relationship</th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Guardian>
			<tr>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Guardian[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
